<template>
    <div class="paper-root" :class="[hideOverflow && 'hide-overflow']">
        <div
            v-if="header"
            class="pl-3 d-flex align-items-center justify-content-between"
            :class="{
                'py-2': !tall && !noHeaderPadding,
                'py-3': (tall || !tall) && !noHeaderPadding,
                'pr-3': !noHeaderPadding,
            }"
        >
            <h6
                class="subtitle bold heading mb-0"
                :style="{
                    'max-width': restrictHeaderWidth ? '90%' : null,
                    'margin-left': offsetHeaderFromLeft ? '50px' : 'none',
                }"
            >
                {{ header.toUpperCase() }}
            </h6>
            <slot name="header" />
        </div>
        <Divider v-if="header" />

        <div
            v-if="padding || custom_padding"
            :class="
                `${
                    custom_padding != ''
                        ? custom_padding
                        : 'p-' + (shouldUseDefaultPadding ? '2' : padding)
                } w-100`
            "
        >
            <slot />
        </div>

        <slot v-else />
    </div>
</template>

<script>
export default {
    name: 'Paper',
    props: {
        header: {
            type: String,
            default: '',
        },
        noHeaderPadding: Boolean,
        info: {
            // Allows for displaying text on the right side of the header
            type: String,
            optional: true,
            default: '',
        },
        restrictHeaderWidth: Boolean,
        offsetHeaderFromLeft: Boolean,
        padding: {
            type: [Boolean, String],
            default: false,
        },
        custom_padding: {
            type: String,
            default: '',
        },
        tall: Boolean, // If the header should have more padding in the y-direction,
        hideOverflow: Boolean,
    },
    computed: {
        shouldUseDefaultPadding() {
            return typeof this.padding === 'boolean';
        },
    },
};
</script>

<style scoped>
.paper-root {
    background-color: white;
    box-shadow: var(--shadow) !important;
    border-radius: 10px;
}
.hide-overflow {
    overflow: hidden;
}
.heading {
    letter-spacing: 1px;
    font-size: 0.7rem;
    font-weight: 600 !important;
}
</style>
